import { render, staticRenderFns } from "./OtherContactAndEnquiryDetail.vue?vue&type=template&id=19168dee&scoped=true&"
import script from "./OtherContactAndEnquiryDetail.vue?vue&type=script&lang=js&"
export * from "./OtherContactAndEnquiryDetail.vue?vue&type=script&lang=js&"
import style0 from "./OtherContactAndEnquiryDetail.vue?vue&type=style&index=0&id=19168dee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19168dee",
  null
  
)

export default component.exports